export const isInReactNativeWebView = () => {
  return typeof window !== "undefined" && !!window.ReactNativeWebView;
};

// The iOS shell can expose window.ReactNativeWebView while its native message
// handler is gone (page in a frame or a closed webview). postMessage then
// throws a TypeError. The loader is cosmetic, so a lost message is not an error.
const postToNative = (mobileData) => {
  try {
    window.ReactNativeWebView.postMessage(JSON.stringify(mobileData));
    return true;
  } catch (_) {
    return false;
  }
};

export const startLoader = (options = {}) => {
  if (!isInReactNativeWebView()) return false;

  return postToNative({
    type: "startLoader",
    options: options,
  });
};

export const stopLoader = (options = {}) => {
  if (!isInReactNativeWebView()) return false;

  return postToNative({
    type: "killLoader",
    ...options,
  });
};
